import React, { useEffect } from "react";
import { Form, Button, Input } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import FormItem from "./FormItem";
import { requiredField } from "utils/crudSagaHelper";

function DynamicList({
    name,
    label,
    placeholder = "Enter item",
    minItems = 1,
    maxItems,
    addButtonClass,
    mode = "edit",
    recordData,
    labelExtra,
    icon: Icon,
    listClass="list-1-column",
    ...props
}) {
    const form = Form.useFormInstance();

    useEffect(() => {
        if (form && mode !== "view") {
            const currentValues = form.getFieldValue(name);
            if (!currentValues || currentValues.length === 0) {
                form.setFieldValue(name, [""]);
            }
        }
    }, [form, name, mode]);

    return (
        <Form.List
            name={name}
            initialValue={[""]}
            rules={[
                requiredField(),
                {
                    validator: async (_, value) => {
                        if (!value || value.length < minItems) {
                            return Promise.reject(
                                new Error(
                                    `At least ${minItems} item${
                                        minItems > 1 ? "s" : ""
                                    } required`
                                )
                            );
                        }
                        return Promise.resolve();
                    },
                },
            ]}
        >
            {(fields, { add, remove }, { errors }) => (
                <>
                    <div className="flex items-center gap-1">
                        {Icon && <Icon className="w-4 h-4 text-purple-600" />}
                        <span className="text-sm label-title">{label}</span>
                        {labelExtra}
                    </div>
                    <div className={`gap-2 mb-3 ${listClass}`}>
                        {fields.map(({ key, name: fieldName, ...restField }, index) => (
                            <div className="flex items-center gap-2">
                                <FormItem {...restField} name={fieldName} className={`font-medium`} noStyle>
                                    <Input
                                        className="input-field"
                                        placeholder={placeholder}
                                        readOnly={mode !== "edit"}
                                    />
                                </FormItem>

                                {(mode === "edit" && fields.length > minItems) && (
                                    <MinusCircleOutlined
                                        className="text-gray-500 dark:text-white cursor-pointer"
                                        onClick={() => remove(fieldName)}
                                    />
                                )}
                            </div>
                        ))}
                    </div>

                    <Form.ErrorList errors={errors} className="mb-2 text-red-500"/>

                    {(mode === "edit" && (!maxItems || fields.length < maxItems)) && (
                        <FormItem>
                            <Button
                                type="dashed"
                                onClick={() => add()}
                                icon={<PlusOutlined />}
                                className={addButtonClass}
                            >
                                Add another
                            </Button>
                        </FormItem>
                    )}
                </>
            )}
        </Form.List>
    );
}

export default DynamicList;
